import { useScrollReveal } from '@/hooks/useScrollReveal';

const stats = [
  { value: '30%', label: 'максимальная комиссия' },
  { value: 'сразу', label: 'выплата после оплаты клиента' },
  { value: '∞', label: 'доход — без ограничений' },
];

export default function PartnerHero() {
  const { ref: headlineRef, revealed: headlineRevealed } = useScrollReveal({ delay: 200 });
  const { ref: subtitleRef, revealed: subtitleRevealed } = useScrollReveal({ delay: 350 });
  const { ref: statsRef, revealed: statsRevealed } = useScrollReveal({ delay: 500 });
  const { ref: btnRef, revealed: btnRevealed } = useScrollReveal({ delay: 650 });

  return (
    <section className="relative w-full min-h-screen flex items-center bg-background-50 overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: 'radial-gradient(circle, oklch(var(--primary-500)) 1px, transparent 1px)',
          backgroundSize: '28px 28px',
        }}
      />

      <div className="absolute top-20 right-0 w-[600px] h-[600px] opacity-[0.06]" style={{ background: 'radial-gradient(circle at center, oklch(var(--primary-500)), transparent 70%)' }} />
      <div className="absolute bottom-10 left-0 w-[500px] h-[500px] opacity-[0.04]" style={{ background: 'radial-gradient(circle at center, oklch(var(--primary-500)), transparent 70%)' }} />

      <div className="absolute top-1/3 right-[10%] hidden lg:block">
        <div className="relative w-20 h-20">
          <div className="absolute inset-0 rounded-full border border-primary-500/20 animate-ping" style={{ animationDuration: '3s' }} />
          <div className="absolute inset-2 rounded-full border border-primary-500/30" />
          <div className="absolute inset-[30%] rounded-full bg-primary-500/10 flex items-center justify-center">
            <i className="ri-hand-coin-line text-primary-500 text-lg"></i>
          </div>
        </div>
      </div>
      <div className="absolute bottom-1/4 left-[8%] hidden lg:block">
        <div className="relative w-16 h-16">
          <div className="absolute inset-0 rounded-full border border-accent-500/15 animate-ping" style={{ animationDuration: '4s', animationDelay: '1s' }} />
          <div className="absolute inset-[25%] rounded-full bg-accent-500/5 flex items-center justify-center">
            <i className="ri-user-add-line text-accent-400 text-base"></i>
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-10 pt-24 md:pt-28 pb-8 md:pb-12 flex flex-col items-start">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 border border-accent-200/60 mb-5 md:mb-6">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-[12px] md:text-[13px] font-semibold text-accent-700 uppercase tracking-[0.1em]">Партнёрская программа</span>
        </div>

        <h1 ref={headlineRef} className={`font-display font-extrabold text-[34px] sm:text-[44px] md:text-[64px] leading-[1.05] tracking-tightest text-foreground-950 max-w-4xl reveal-fade-up ${headlineRevealed ? 'revealed' : ''}`}>
          Зарабатывайте с AIGAM — до 30% с каждого приведённого клиента
        </h1>

        <p ref={subtitleRef} className={`mt-4 md:mt-8 text-[15px] md:text-[19px] text-foreground-500 max-w-2xl leading-relaxed reveal-fade-up ${subtitleRevealed ? 'revealed' : ''}`}>
          Рекомендуйте AIGAM компаниям, которым нужны клиенты. Мы платим процент с каждой покупки — от подписки до комплексного запуска. Выплаты приходят сразу после поступления оплаты от клиента.
        </p>

        <div ref={statsRef} className={`mt-6 md:mt-10 flex flex-wrap gap-4 md:gap-8 reveal-fade-up ${statsRevealed ? 'revealed' : ''}`}>
          {stats.map((stat) => (
            <div key={stat.label} className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center shrink-0">
                <span className="font-display font-bold text-primary-700 text-sm md:text-base">
                  {stat.value}
                </span>
              </div>
              <span className="text-[13px] md:text-[15px] text-foreground-600 leading-snug max-w-[120px] md:max-w-[160px]">{stat.label}</span>
            </div>
          ))}
        </div>

        <div ref={btnRef} className={`mt-6 md:mt-10 reveal-fade-up ${btnRevealed ? 'revealed' : ''}`}>
          <a
            href="https://t.me/anna_aigam"
            target="_blank"
            rel="noopener noreferrer"
            className="h-11 md:h-12 px-6 md:px-7 inline-flex items-center justify-center rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-[14px] md:text-[15px] font-semibold transition-colors whitespace-nowrap cursor-pointer"
          >
            Стать партнёром в Telegram
          </a>
        </div>
      </div>
    </section>
  );
}